import { getApiErrorPayload } from './apiErrors'

export type CaptchaRequiredError = Error & {
  requiresCaptcha: true
  captchaSiteKey?: string
}

export function createCaptchaRequiredError(
  message: string,
  siteKey?: string | null,
): CaptchaRequiredError {
  const err = new Error(message) as CaptchaRequiredError
  err.requiresCaptcha = true
  if (siteKey) err.captchaSiteKey = siteKey
  return err
}

export function isCaptchaRequiredError(err: unknown): err is CaptchaRequiredError {
  return Boolean(
    err &&
      typeof err === 'object' &&
      (err as CaptchaRequiredError).requiresCaptcha === true,
  )
}

/** Pull requires_captcha + site key from a FastAPI error body if present. */
export function parseCaptchaRequiredFromResponse(data: unknown): {
  required: boolean
  siteKey?: string
} {
  const detail = getApiErrorPayload(data)
  if (!detail || typeof detail !== 'object') {
    return { required: false }
  }
  const obj = detail as Record<string, unknown>
  if (!obj.requires_captcha) {
    return { required: false }
  }
  return {
    required: true,
    siteKey: typeof obj.captcha_site_key === 'string' ? obj.captcha_site_key : undefined,
  }
}
